import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import { isOverDue, pageSizeOptions } from "utils/HelperFunction";
import SoDocStatus from "layouts/SoDocStatus";
import useInitDoDataList from "hooks/deliveryOrder/useInitDoDataList";
import DoDocStatus from "layouts/DoDocStatus";
import DocStatus from "layouts/DocStatus";
import { isDoOverDue } from "utils/HelperDoFunction";
export default function LoadDeliverOrder(_param) {
    var setFormdata = _param.setFormdata, setProductRow = _param.setProductRow, setPdata = _param.setPdata, setModal = _param.setModal, loadDocDataProcess = _param.loadDocDataProcess, props = _object_without_properties(_param, [
        "setFormdata",
        "setProductRow",
        "setPdata",
        "setModal",
        "loadDocDataProcess"
    ]);
    var _useInitDoDataList = useInitDoDataList({
        initStatus: 4,
        isReadyToDelivery: true
    }), pageModel = _useInitDoDataList.pageModel, setPageModel = _useInitDoDataList.setPageModel, filterText = _useInitDoDataList.filterText, setFilterText = _useInitDoDataList.setFilterText, data = _useInitDoDataList.data, setData = _useInitDoDataList.setData, btnempstatus = _useInitDoDataList.btnempstatus, setBtnempstatus = _useInitDoDataList.setBtnempstatus, getData = _useInitDoDataList.getData, isMemoLoading = _useInitDoDataList.isMemoLoading;
    var _useState = _sliced_to_array(useState(null), 2), docSelected = _useState[0], setDocSelected = _useState[1];
    var columnsd = [
        {
            field: "id",
            headerName: "",
            width: 100,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Form.Check, {
                    type: "radio",
                    id: "t".concat(row.id),
                    className: "form-check-st-2 tc-7 ms-4",
                    checked: docSelected && docSelected.id === row.id,
                    onChange: function() {
                        setDocSelected(row);
                    }
                });
            }
        },
        {
            field: "doc_number",
            headerName: "เลขที่ใบเสนอราคา",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/sale/quotation/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "full_member_name",
            headerName: "ชื่อลูกค้า",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.full_member_name,
                        row.member_branch_no && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                "(",
                                row.member_is_hq ? "สำนักงานใหญ่" : row.member_branch_no,
                                ")"
                            ]
                        })
                    ]
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dim_mst_payment_type_id",
            headerName: "เงื่อนไขชำระเงิน",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimMstPaymentType.name
                });
            }
        },
        {
            field: "sum_item_quantity",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        },
        {
            field: "dim_mst_do_status_id",
            headerName: "สถานะ",
            width: 180,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row.dim_mst_do_status_id;
                var statusName = row.dimMstDoStatus.name;
                var isOverDue = isDoOverDue({
                    dueDeliveryDate: row.delivery_date,
                    deliveredSuccess: row.updated_success_delivery_at,
                    statusID: statusID
                });
                return /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center flex-col",
                    children: [
                        /*#__PURE__*/ _jsx(DoDocStatus, {
                            statusID: statusID,
                            statusName: statusName,
                            isOverDue: isOverDue
                        }, "do-load-status-".concat(row.id)),
                        row.dimMstDoStatus.id === 2 && row.ready_to_delivery_date && /*#__PURE__*/ _jsx(DocStatus, {
                            className: "!text-[14px]",
                            statusName: "พร้อมส่ง",
                            statusID: "overdue"
                        }),
                        !row.is_delivery_success && row.undelivered_reason && /*#__PURE__*/ _jsx(DocStatus, {
                            className: "!text-[14px]",
                            statusName: "ส่งไม่สำเร็จ",
                            statusID: "overdue"
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "do-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center  mb-3 flex-wrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "me-3 mb-2",
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control form-st-4",
                            placeholder: "เลขที่เอกสาร / ชื่อลูกค้า",
                            onChange: function(e) {
                                return setFilterText(e.target.value);
                            },
                            value: filterText
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: function() {
                            return setFilterText("");
                        },
                        className: "btn btn btn-st-3 mb-2 px-4",
                        children: "ล้างค่าการค้นหา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    width: "100%"
                },
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    loading: isMemoLoading,
                    getRowId: function(row) {
                        return row.id;
                    },
                    getRowHeight: function() {
                        return "auto";
                    },
                    rows: data,
                    pagination: true,
                    paginationMode: "server",
                    paginationModel: {
                        page: pageModel.page - 1,
                        pageSize: pageModel.pageSize
                    },
                    onPaginationModelChange: function(newPagination) {
                        setPageModel(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                page: newPagination.page + 1,
                                pageSize: newPagination.pageSize
                            });
                        });
                        getData({
                            page: newPagination.page + 1,
                            limit: newPagination.pageSize,
                            searchText: filterText || "",
                            mstNewStatusID: btnempstatus
                        });
                    },
                    rowsPerPage: pageModel.page,
                    rowCount: pageModel.total,
                    columns: columnsd,
                    pageSizeOptions: pageSizeOptions,
                    disableRowSelectionOnClick: true,
                    slotProps: {
                        pagination: {
                            labelRowsPerPage: "จำนวนรายการต่อหน้า"
                        }
                    },
                    autoHeight: true
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center pb-4 pt-5 ",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-6 me-3 btn",
                        onClick: function() {
                            return setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-3 ",
                        onClick: function() {
                            loadDocDataProcess({
                                docSelected: docSelected,
                                setProductRow: setProductRow,
                                setFormdata: setFormdata,
                                setPdata: setPdata
                            });
                            setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        disabled: !docSelected,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    });
}
